import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import '@/styles/element-plus-theme.css';
import '@/styles/cotizador-theme.css';
import '@/styles/widget-tokens.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import CotizadorApp from '@/components/CotizadorApp.vue';
import '@/styles/globals.css';
import type { WidgetOptions } from './types';

export function buildWidgetApp(options: WidgetOptions, allowEmission: boolean): ReturnType<typeof createApp> {
  const pinia = createPinia();
  const app = createApp(CotizadorApp, {
    showBackground: options.showBackground ?? true,
    backgroundImage: options.backgroundImage,
    size: options.size ?? 'auto',
    fullHeight: options.fullHeight ?? false,
    primaryColor: options.primaryColor,
    secondaryColor: options.secondaryColor,
    fontPrimary: options.fontPrimary,
    fontSecondary: options.fontSecondary,
    allowEmission,
    xcf: options.xcf === true,
  });

  app.use(pinia);
  app.use(ElementPlus);

  // Register all icons
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }

  return app;
}
